import React from "react";
import { Select } from "antd";

/**
 * Shared account-type selector — Regular / Demo / Test.
 *
 * `value` is the stored account_type: `null` (Regular — a normal user),
 * `"demo"`, or `"test"`. Demo is only meaningful on the `@dashmote.com` staff
 * domain (it scopes a staff account out of implicit all-workspace access), so
 * the Demo option is disabled unless `demoAllowed`. A plain Select is used
 * (not a Segmented) so it stays legible on any background — the previous
 * segmented control rendered near-invisible on the purple card.
 *
 * Used by the Create User + Invite Users modals and the User Scope Management
 * inline editor so all three surfaces present the same control.
 */
export default function AccountTypeSelect({
  value = null,
  onChange,
  demoAllowed = false,
  loading = false,
  disabled = false,
  size = "middle",
  style,
}) {
  return (
    <Select
      aria-label="Account type"
      value={value || "regular"}
      loading={loading}
      disabled={disabled}
      size={size}
      style={{ minWidth: 180, ...style }}
      onChange={(v) => onChange?.(v === "regular" ? null : v)}
      options={[
        { label: "Regular", value: "regular" },
        {
          // Demo requires @dashmote.com; annotate the label when it's not
          // selectable so the reason is visible, not just a greyed option.
          label: demoAllowed ? "Demo" : "Demo (@dashmote.com only)",
          value: "demo",
          disabled: !demoAllowed,
        },
        { label: "Test", value: "test" },
      ]}
    />
  );
}
